import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import { APP_TITLE } from '../../../utils/constants';
import { createStyles, makeStyles, Paper, Theme } from '@material-ui/core';
import { GetString } from '../../../components/StringResourceManager';
import { CommandRequestHistory } from '../../../components/Config/History/CommandRequestHistory';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  })
);

export default function ConfigHistorySubMenu() {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_HISTORY')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('PAGE_TITLE_HISTORY')} />
      <Paper className={classes.paperGrid}>
        <CommandRequestHistory />
      </Paper>
    </>
  );
}
